import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="hakkimizda" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <div className="reveal">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('about.title')}
          </h2>
        </div>

        <div className="reveal reveal-delay-1">
          <p className="text-base leading-relaxed text-foreground-600 md:text-lg">
            {t('about.text')}
          </p>
        </div>
      </div>
    </section>
  );
}